export function createQuery(){
    return `
    from(bucket: "telegraf")
        |> range(start: -1y)
        |> filter(fn: (r) => 
            (r["_measurement"] == "ezelink_memory_value" and r["type"] == "percent" and (
            r["type_instance"] == "free" or
            r["type_instance"] == "cached" or
            r["type_instance"] == "buffered" or
            r["type_instance"] == "used"
            )) or
            (r["_measurement"] == "ezelink_df_value" and r["instance"] == "root" and r["type"] == "percent_bytes" and r["type_instance"] == "used") or
            r["_measurement"] == "ezelink_uptime_value" or
            r["_measurement"] == "ezelink_cpu_value" or
            r["_measurement"] == "ezelink_interface_value" or
            r["_measurement"] == "snmp" or 
            r["_measurement"] == "hr_storage" or
            r["_measurement"] == "cpu_system_stats"
        )
        |> group(columns: ["host", "_measurement", "_field", "type_instance", "instance"])
        |> last()
    `;
} 